import React, { useState, useEffect } from "react";
import { supabase } from "../../supabase";

export default function MobileLanding() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState("signup");
  const [authData, setAuthData] = useState({ email: "", password: "" });
  const [authError, setAuthError] = useState("");
  const [authLoading, setAuthLoading] = useState(false);

  useEffect(() => {
    checkUser();
  }, []);

  const checkUser = async () => {
    const {
      data: { user },
    } = await supabase.auth.getUser();
    if (user) {
      window.location.href = "/explore";
    }
  };

  const openAuthModal = (mode) => {
    setAuthMode(mode);
    setShowAuthModal(true);
    setAuthError("");
    setAuthData({ email: "", password: "" });
  };

  const handleGoogleSignIn = async () => {
    setAuthLoading(true);
    setAuthError("");
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: { redirectTo: `${window.location.origin}/auth/callback` },
      });
      if (error) throw error;
    } catch (error) {
      setAuthError(error.message || "Failed to sign in with Google");
      setAuthLoading(false);
    }
  };

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setAuthLoading(true);
    setAuthError("");

    if (authMode === "signup") {
      try {
        const { data, error } = await supabase.auth.signUp({
          email: authData.email,
          password: authData.password,
        });
        if (error) throw error;

        if (data?.user) {
          await supabase.from("user_profiles").insert([
            {
              user_id: data.user.id,
              email: authData.email,
              full_name: "",
              created_at: new Date().toISOString(),
            },
          ]);
          window.location.href = "/onboarding";
        }
      } catch (error) {
        setAuthError(error.message || "Failed to create account");
      } finally {
        setAuthLoading(false);
      }
    } else {
      try {
        const { error } = await supabase.auth.signInWithPassword({
          email: authData.email,
          password: authData.password,
        });
        if (error) throw error;
        window.location.href = "/explore";
      } catch (error) {
        setAuthError(error.message || "Failed to sign in");
      } finally {
        setAuthLoading(false);
      }
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#ffffff",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}
    >
      {/* Navbar */}
      <header
        style={{
          padding: "16px 20px",
          position: "sticky",
          top: 0,
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          backdropFilter: "blur(10px)",
          zIndex: 1000,
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: "1100px",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              fontSize: "22px",
              fontWeight: "700",
              letterSpacing: "-0.5px",
              color: "#111827",
            }}
          >
            Collavo
          </div>
          <button
            onClick={() => openAuthModal("signin")}
            style={{
              backgroundColor: "transparent",
              color: "#111827",
              padding: "8px 20px",
              fontSize: "14px",
              fontWeight: "600",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Sign In
          </button>
        </div>
      </header>

      {/* Hero */}
      <section
        style={{
          padding: "60px 24px 40px",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: "38px",
            fontWeight: "700",
            color: "#111827",
            marginBottom: "8px",
            letterSpacing: "-0.5px",
            lineHeight: "1.2",
          }}
        >
          The home to church collaboration
        </h1>
        <p
          style={{
            color: "#6B7280",
            fontSize: "16px",
            margin: "0 0 40px 0",
          }}
        >
          Share your gifts. Serve where you're needed.
        </p>

        {/* CTA Buttons */}
        <div
          style={{
            maxWidth: "320px",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <button
            onClick={() => openAuthModal("signup")}
            style={{
              width: "100%",
              padding: "16px 24px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#ffffff",
              // backgroundColor: "#F97316",
              backgroundColor: "#36454F",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Sign Up
          </button>

          <button
            onClick={() => openAuthModal("signin")}
            style={{
              width: "100%",
              padding: "16px 24px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#374151",
              backgroundColor: "transparent",
              border: "1px solid #d1d5db",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Log In
          </button>
          <p
            style={{
              fontSize: "12px",
              color: "#9CA3AF",
              margin: "0",
              lineHeight: "1.5",
            }}
          >
            By signing up, you agree to Collavo's{" "}
            <a
              href="/terms"
              style={{ color: "#6B7280", textDecoration: "underline" }}
            >
              Terms of Use
            </a>{" "}
            and{" "}
            <a
              href="/privacy"
              style={{ color: "#6B7280", textDecoration: "underline" }}
            >
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </section>

      {/* Auth Modal */}
      {showAuthModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "24px",
          }}
          onClick={() => setShowAuthModal(false)}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              padding: "32px 24px",
              borderRadius: "16px",
              maxWidth: "400px",
              width: "100%",
              border: "1px solid #e5e7eb",
              boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <h2
              style={{
                fontSize: "22px",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "6px",
                color: "#111827",
              }}
            >
              {authMode === "signup" ? "Create your account" : "Welcome back"}
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: "#6B7280",
                textAlign: "center",
                marginBottom: "24px",
              }}
            >
              {authMode === "signup"
                ? "Join the Collavo community"
                : "Sign in to continue"}
            </p>

            {authError && (
              <div
                style={{
                  backgroundColor: "rgba(220, 38, 38, 0.05)",
                  color: "#dc2626",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  fontSize: "14px",
                  marginBottom: "20px",
                  border: "1px solid rgba(220, 38, 38, 0.2)",
                }}
              >
                {authError}
              </div>
            )}

            {/* Google Sign In */}
            <button
              onClick={handleGoogleSignIn}
              disabled={authLoading}
              style={{
                width: "100%",
                padding: "14px",
                fontSize: "15px",
                fontWeight: "600",
                backgroundColor: "#f9fafb",
                color: "#111827",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                cursor: authLoading ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "12px",
                marginBottom: "20px",
                opacity: authLoading ? 0.6 : 1,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path
                  fill="#4285F4"
                  d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
                />
                <path
                  fill="#34A853"
                  d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z"
                />
                <path
                  fill="#FBBC05"
                  d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707s.102-1.167.282-1.707V4.961H.957C.347 6.175 0 7.55 0 9s.348 2.825.957 4.039l3.007-2.332z"
                />
                <path
                  fill="#EA4335"
                  d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.961L3.964 7.293C4.672 5.163 6.656 3.58 9 3.58z"
                />
              </svg>
              {authLoading ? "Loading..." : "Continue with Google"}
            </button>

            {/* Divider */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }}
              />
              <span style={{ fontSize: "13px", color: "#9CA3AF" }}>or</span>
              <div
                style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }}
              />
            </div>

            {/* Email Input */}
            <input
              type="email"
              placeholder="Email"
              value={authData.email}
              onChange={(e) =>
                setAuthData((prev) => ({ ...prev, email: e.target.value }))
              }
              disabled={authLoading}
              style={{
                width: "100%",
                padding: "14px 16px",
                fontSize: "15px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                marginBottom: "12px",
                boxSizing: "border-box",
                outline: "none",
                backgroundColor: "#ffffff",
                color: "#111827",
              }}
              onFocus={(e) => {
                // e.currentTarget.style.borderColor = "#F97316";
                e.currentTarget.style.borderColor = "#36454F";

                e.currentTarget.style.boxShadow =
                  "0 0 0 3px rgba(249, 115, 22, 0.1)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = "#d1d5db";
                e.currentTarget.style.boxShadow = "none";
              }}
            />

            {/* Password Input */}
            <input
              type="password"
              placeholder="Password"
              value={authData.password}
              onChange={(e) =>
                setAuthData((prev) => ({ ...prev, password: e.target.value }))
              }
              disabled={authLoading}
              style={{
                width: "100%",
                padding: "14px 16px",
                fontSize: "15px",
                border: "1px solid #d1d5db",
                borderRadius: "8px",
                marginBottom: "20px",
                boxSizing: "border-box",
                outline: "none",
                backgroundColor: "#ffffff",
                color: "#111827",
              }}
              onFocus={(e) => {
                // e.currentTarget.style.borderColor = "#F97316";
                e.currentTarget.style.borderColor = "#36454F";

                e.currentTarget.style.boxShadow =
                  "0 0 0 3px rgba(249, 115, 22, 0.1)";
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = "#d1d5db";
                e.currentTarget.style.boxShadow = "none";
              }}
            />

            {/* Submit Button */}
            <button
              onClick={handleEmailAuth}
              disabled={authLoading}
              style={{
                width: "100%",
                padding: "14px",
                fontSize: "15px",
                fontWeight: "600",
                // backgroundColor: "#F97316",
                backgroundColor: "#36454F",
                color: "#ffffff",
                border: "none",
                borderRadius: "8px",
                cursor: authLoading ? "not-allowed" : "pointer",
                marginBottom: "20px",
                opacity: authLoading ? 0.7 : 1,
              }}
            >
              {authLoading
                ? "Loading..."
                : authMode === "signup"
                  ? "Create Account"
                  : "Sign In"}
            </button>

            {/* Toggle Auth Mode */}
            <p
              style={{
                fontSize: "14px",
                color: "#6B7280",
                textAlign: "center",
                margin: 0,
              }}
            >
              {authMode === "signup" ? (
                <>
                  Already have an account?{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setAuthMode("signin");
                      setAuthError("");
                    }}
                    style={{
                      // color: "#F97316",
                      color: "#36454F",
                      fontWeight: "600",
                      textDecoration: "none",
                    }}
                  >
                    Sign In
                  </a>
                </>
              ) : (
                <>
                  Don't have an account?{" "}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setAuthMode("signup");
                      setAuthError("");
                    }}
                    style={{
                      // color: "#F97316",
                      color: "#36454F",
                      fontWeight: "600",
                      textDecoration: "none",
                    }}
                  >
                    Sign Up
                  </a>
                </>
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
